export const UNLIMITED_OPENING_MONTHS = 1000
export const ALWAYS_OPEN = 0
